export const PHONE_900 = '900 110 619';
export const PHONE_1004 = '1004';

export const DEFAULT_ERROR_PAGE_TEXT = {
  ERROR_ID: 'ERROR-PAGE',
  TITLE: ' Ha ocurrido un error',
  DESCRIPTION:
    'No es posible continuar debido a problemas técnicos. Por favor, inténtalo más tarde.',
  BUTTON_TEXT: 'Entendido',
  BUTTON_HREF: 'https://www.movistar.es/',
};
export const SHOP_ERROR_PAGE_TEXT = {
  ERROR_ID: 'SHOP-PAGE',
  TITLE: 'Añadir nuevo medio',
  DESCRIPTION:
    'Para realizar esta gestión, por favor llama al 1004 o acude a una de nuestras tiendas',
  BUTTON_TEXT: 'Entendido',
  BUTTON_HREF: 'https://www.movistar.es/',
};
export const DEFAULT_ERROR_MODAL_TEXT = {
  ERROR_ID: 'DEFAULT_ERROR_MODAL',
  BUTTON_TEXT: 'Entendido',
  BUTTON_HREF: 'https://www.movistar.es/',
};
